/* ===== Helpers ===== */

function resetSelections() {
  $(".selected_option").html("&nbsp;");
  $(".selected_option_color").html("&nbsp;");
  $(".selected_option_LogoSize").html("&nbsp;");
  $(".selected_option_logo").html("&nbsp;");
  $(".swatch-element-select").removeClass("active");
  $(".swatch-element-select-color").removeClass("active");
  $(".swatch-element-select-logo").removeClass("active");
}

function closeSidebar() {
  $(".alert-danger").remove();
  $(".product__customization_sidebar").css("transform", "translateX(100%)");
  $(".product__customization_sidebar input")
    .removeClass("required")
    .removeAttr("required");
  $(".sidebar_model").css("transform", "translateX(100%)");
  $(".product__customization_sidebar_overlay").remove();
  $("html, body").removeClass("noscroll");
  $(".product__customization_sidebar input[type=radio]").prop("checked", false);
  $(
    ".product__customization_sidebar input[type=text], .product__customization_sidebar textarea, .product__customization_sidebar input[type=file]",
  ).val("");
  resetSelections();
  ajaxCart.load();
}

function scrollToProduct(classname) {
  var el = document.querySelector(classname);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
}

function getQty() {
  return parseInt($(".velaQtyNum").val()) || 1;
}

function addToCartItems(brodeireItems, mainProperties, endpoint) {
  endpoint = endpoint || "cart/add.js";
  $("body").addClass("velaCartAdding");

  const pending = window.ATB?._pendingAlterations || [];
  const qty = getQty();

  const formData = new FormData();

  formData.append("id", parseInt($("#productSelect").val()));
  formData.append("quantity", qty);

  const cleanProperties = {};

  Object.entries(mainProperties || {}).forEach(function ([key, value]) {
    if (value === undefined || value === "") return;

    // Ne jamais envoyer fakepath comme propriété logo
    if ((key === "logo" || key === "Logo") && String(value).includes("fakepath")) {
      return;
    }

    cleanProperties[key] = value;
    formData.append(`properties[${key}]`, value);
  });

  // Ajouter les vrais fichiers logo
  const logoInput = document.querySelector('input[type="file"][name="properties[logo]"]');
  const logoBothInput = document.querySelector('input[type="file"][name="properties[Logo]"]');

  if (logoInput?.files?.[0]) {
    formData.append("properties[logo]", logoInput.files[0]);
  }

  if (logoBothInput?.files?.[0]) {
    formData.append("properties[Logo]", logoBothInput.files[0]);
  }

  const titles = pending
    .map((id) => window.ATB?.alterationTitles?.[id])
    .filter(Boolean);

  if (titles.length) {
    cleanProperties.Retouche = titles.join(", ");
    formData.append("properties[Retouche]", cleanProperties.Retouche);
  }

  const hasFile = !!logoInput?.files?.[0] || !!logoBothInput?.files?.[0];

  const uid = hasFile
    ? `uid_${Date.now()}_${Math.random().toString(36).slice(2)}`
    : window.ATB.buildUid(cleanProperties);

  if (uid) {
    formData.append("properties[_uid]", uid);
  }

  return fetch("/cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((r) => r.json())
    .then(function (parent) {
      const parentUid = parent.properties._uid;
      const parentLabel = [parent.product_title, parent.variant_title]
        .filter(Boolean)
        .join(" — ");

      const promises = [];

      if (brodeireItems && brodeireItems.length) {
        promises.push(
          fetch(window.Shopify.routes.root + endpoint, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: brodeireItems.map((item) => ({
                ...item,
                quantity: qty,
                properties: {
                  "Associé à": parentLabel,
                  _uid: uid,
                  _atb_role: "child",
                },
              })),
            }),
          })
        );
      }

      if (pending.length) {
        pending.forEach(function (variantId) {
          promises.push(window.ATB.addAlteration(variantId, parentUid, qty));
        });
      }

      return Promise.all(promises).finally(function () {
        if (window.ATB) window.ATB._pendingAlterations = [];
        $("body").removeClass("velaCartAdding");
      });
    })
    .then(() => closeSidebar())
    .catch(function (err) {
      console.error("addToCart error:", err);
      $("body").removeClass("velaCartAdding");
    });
}/* ===== Sidebar open/close ===== */

$(".product__customization_container").click(function () {
  $("html, body").addClass("noscroll");
  $("body").append(
    "<div class='product__customization_sidebar_overlay'></div>",
  );
  $(".product__customization_sidebar").css("transform", "translateX(0)");
});

$(".product__customization__close-sidebar").click(function () {
  $(".product__customization_sidebar").css("transform", "translateX(100%)");
  $(".product__customization_sidebar input")
    .removeClass("required")
    .removeAttr("required");
  $(".sidebar_model").css("transform", "translateX(100%)");
  $(".product__customization_sidebar_overlay").remove();
  $("html, body").removeClass("noscroll");
  $(".alert-danger").remove();
  $(".product__customization_sidebar input[type=radio]").prop("checked", false);
  $(
    ".product__customization_sidebar input[type=text], .product__customization_sidebar textarea, .product__customization_sidebar input[type=file]",
  ).val("");
  resetSelections();
});

$("a.select_link").click(function () {
  var target = $(this).attr("data-show");
  $(target)
    .find(".sidebar_model_carousel .carousel")
    .not(".slick-initialized")
    .slick({
      slidesToShow: 1,
      dots: true,
      adaptiveHeight: true,
      centerPadding: "0px",
    });
  $(target).css("transform", "translateX(0)");
  $(target).find("input").attr("required", "required").addClass("required");
});

$(".product__customization__back, .btnCancelAddToCart").click(function () {
  var model = $(this).parents(".sidebar_model");
  model.css("transform", "translateX(100%)");
  model.find("input").removeAttr("required").removeClass("required");
  $(".alert-danger").remove();
  model.find("input[type=radio]").prop("checked", false);
  model.find("input[type=text], textarea, input[type=file]").val("");
  resetSelections();
});

/* ===== Swatches ===== */

$('input[type=radio][name="properties[fonts]"]').change(function () {
  $(
    ".header.select__fonts .alert-danger, .header.select__fonts_both .alert-danger",
  ).remove();
  $(".swatch-element-select").removeClass("active");
  $(this).parents(".swatch-element-select").addClass("active");
  $(".selected_option").html("&nbsp;" + this.value);
  $(".swatch-select .swatch-element-select-text input").css(
    "font-family",
    this.dataset.font || this.value,
  );
});

$('input[type=radio][name="properties[color]"]').change(function () {
  $(
    ".header.select__colors .alert-danger, .header.select__colors_both .alert-danger",
  ).remove();
  $(".swatch-element-select-color").removeClass("active");
  $(this).parents(".swatch-element-select-color").addClass("active");
  $(".selected_option_color").html("&nbsp;" + this.value);
});

$('input[type=radio][name="properties[Logo Size]"]').change(function () {
  $(
    ".header.select__logo_size .alert-danger, .header.select__logo_size_both .alert-danger",
  ).remove();
  $(".swatch-element-select-logo").removeClass("active");
  $(this).parents(".swatch-element-select-logo").addClass("active");
  $(".selected_option_LogoSize").html("&nbsp;" + this.value);
});

$('input[type=text][name="properties[text]"].v-text').keyup(function () {
  if ($.trim($(this).val())) $(".header.select__text .alert-danger").remove();
});

$('input[type=text][name="properties[text]"].v-both').keyup(function () {
  if ($.trim($(this).val()))
    $(".header.select__text_both .alert-danger").remove();
});

$(".swatch-element-select-logo").on(
  "change",
  'input[type=file][name="properties[logo]"]',
  function () {
    $(".header.select__logo .alert-danger").remove();
    $(".selected_option_logo").html(
      "&nbsp;" +
        $(this)
          .val()
          .replace(/C:\\fakepath\\/i, ""),
    );
  },
);

$(".swatch-element-select-logo").on(
  "change",
  'input[type=file][name="properties[Logo]"]',
  function () {
    $(".header.select__logo_both .alert-danger").remove();
    $(".selected_option_logo").html(
      "&nbsp;" +
        $(this)
          .val()
          .replace(/C:\\fakepath\\/i, ""),
    );
  },
);

/* ===== Validation helpers ===== */

function showError(selector, msg) {
  $(selector + " .alert-danger").remove();
  $(selector).append("<p class='alert-danger'>* " + msg + "</p>");
  scrollToProduct(selector);
}

function showErrorInAccordion(model, msg) {
  showError(model + " .alert-wrapper", msg);
  var accordionEl = document.querySelector(model + " [data-module-accordion]");
  if (accordionEl) accordionEl.dispatchEvent(new CustomEvent("accordion:recalculate"));
}

/* ===== Add to cart — Broderie texte ===== */

$("#AddToCartText").click(function () {
  var model = "#model_2";

  if (
    !$(model + ' input[type=radio][name="properties[fonts]"]').is(":checked")
  ) {
    return showError(".select__fonts", "veuillez en sélectionner un");
  }
  if (
    !$(model + ' input[type=radio][name="properties[color]"]').is(":checked")
  ) {
    return showError(".select__colors", "veuillez en sélectionner un");
  }
  if (
    !$(model + ' input[type=text][name="properties[text]"]')
      .val()
      .trim()
  ) {
    return showError(".select__text", "Ce champ est obligatoire");
  }

  var isLine2 = $(model + " [data-module-accordion]")
    .find(".atb-bat-input")
    .is(":checked");

  if (
    isLine2 &&
    !$(model + ' input[type=text][name="properties[text2]"]').val().trim()
  ) {
    return showErrorInAccordion(model, "Ce champ est obligatoire");
  }

  var items = [{ id: window.ATB.specialProductVariantMap.text }];
  if (isLine2)
    items.push({
      id: window.ATB.specialProductVariantMap.second_line,
    });

  addToCartItems(
    items,
    {
      fonts: $(
        model + ' input[type=radio][name="properties[fonts]"]:checked',
      ).val(),
      color: $(
        model + ' input[type=radio][name="properties[color]"]:checked',
      ).val(),
      text: $(model + ' input[type=text][name="properties[text]"]')
        .val()
        .trim(),
      text2: isLine2
        ? $(model + ' input[type=text][name="properties[text2]"]')
            .val()
            .trim()
        : undefined,
    },
    "cart/add.js?_easygift_apply_rules=false",
  );
});

/* ===== Add to cart — Broderie logo ===== */

$("#AddToCartLogo").click(function () {
  var model = "#model_3";

  if (
    !$(model + ' input[type=radio][name="properties[Logo Size]"]').is(
      ":checked",
    )
  ) {
    return showError(".select__logo_size", "veuillez en sélectionner un");
  }
  if (!$.trim($(model + " input[type=file]").val())) {
    return showError(".select__logo", "Ce champ est obligatoire");
  }

  addToCartItems([{ id: window.ATB.specialProductVariantMap.logo }], {
    "Logo Size": $(
      model + ' input[type=radio][name="properties[Logo Size]"]:checked',
    ).val(),
    logo: $(model + ' input[type=file][name="properties[logo]"]').val(),
    notes: $(model + ' textarea[name="properties[notes]"]').val(),
  });
});

/* ===== Add to cart — Broderie texte + logo ===== */

$("#AddToCartBoth").click(function () {
  var model = "#model_4";

  if (
    !$(model + ' input[type=radio][name="properties[Logo Size]"]').is(
      ":checked",
    )
  ) {
    return showError(".select__logo_size_both", "veuillez en sélectionner un");
  }
  if (!$.trim($(model + " input[type=file]").val())) {
    return showError(".select__logo_both", "Ce champ est obligatoire");
  }
  if (
    !$(model + ' input[type=radio][name="properties[fonts]"]').is(":checked")
  ) {
    return showError(".select__fonts_both", "veuillez en sélectionner un");
  }
  if (
    !$(model + ' input[type=radio][name="properties[color]"]').is(":checked")
  ) {
    return showError(".select__colors_both", "veuillez en sélectionner un");
  }
  if (
    !$(model + ' input[type=text][name="properties[text]"]')
      .val()
      .trim()
  ) {
    return showError(".select__text_both", "Ce champ est obligatoire");
  }

  var isLine2 = $(model + " [data-module-accordion]")
    .find(".atb-bat-input")
    .is(":checked");

  if (
    isLine2 &&
    !$(model + ' input[type=text][name="properties[text2]"]').val().trim()
  ) {
    return showErrorInAccordion(model, "Ce champ est obligatoire");
  }

  var items = [{ id: window.ATB.specialProductVariantMap.both }];
  if (isLine2)
    items.push({
      id: window.ATB.specialProductVariantMap.second_line,
    });

  addToCartItems(items, {
    "Logo Size": $(
      model + ' input[type=radio][name="properties[Logo Size]"]:checked',
    ).val(),
    Logo: $(model + ' input[type=file][name="properties[Logo]"]').val(),
    Notes: $(model + ' textarea[name="properties[Notes]"]').val(),
    fonts: $(
      model + ' input[type=radio][name="properties[fonts]"]:checked',
    ).val(),
    color: $(
      model + ' input[type=radio][name="properties[color]"]:checked',
    ).val(),
    text: $(model + ' input[type=text][name="properties[text]"]')
      .val()
      .trim(),
    text2: isLine2
      ? $(model + ' input[type=text][name="properties[text2]"]')
          .val()
          .trim()
      : undefined,
  });
});

/* ===== Sync champs dupliqués ===== */

document.addEventListener("DOMContentLoaded", function () {
  ["properties[text]", "properties[text2]"].forEach(function (name) {
    var inputs = document.querySelectorAll('input[name="' + name + '"]');
    if (inputs.length < 2) return;
    inputs.forEach(function (input) {
      input.addEventListener("input", function () {
        inputs.forEach(function (other) {
          if (other !== input) other.value = input.value;
        });
      });
    });
  });
});

window.addEventListener("pageshow", function (event) {
  document.querySelectorAll("[data-module-accordion]").forEach(function (el) {
    const checkbox = el.querySelector(".atb-bat-input");
    if (checkbox) checkbox.checked = false;

    const content = el.querySelector('[data-accordion="content"]');
    if (content) {
      content.style.setProperty("--height", "0px");
      content.classList.remove("on-toggle", "is-active");
    }
    el.classList.remove("is-active");
    const trigger = el.querySelector('[data-accordion="trigger"]');
    if (trigger) trigger.classList.remove("is-active");
  });
});
